import styled from '@emotion/styled';
import { rem } from '@app/styles/theme/layout';
import { Box } from '@rebass/emotion';

export const StockIndicatorWrapper = styled(Box)`
  margin-top: ${rem(30)};
  margin-bottom: ${rem(30)};
  font-size: ${rem(15)};
`;
